import { render, staticRenderFns } from "./addCouponPropertyPool.vue?vue&type=template&id=58205a2e"
import script from "./addCouponPropertyPool.vue?vue&type=script&lang=js"
export * from "./addCouponPropertyPool.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports